/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {completeCopyModal} from '../common/util/complete-copy-modal';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './line-item-copy-modal.component.html';
import {nextCopyTitle} from '../../components/util/next-copy-title';
import {Uuid} from '../../components/util/uuid';
import {LineItemResource} from '../../components/api/resources/resource/line-item.resource';
import {AdnModalLoadingService} from '../common/util/adn-modal-loading.service';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';

export interface LineItemCopyResult {
  lineItemId: string;
  destination: boolean;
}

@Component({
  standalone: false,
  selector: 'adn-line-item-copy-modal',
  template
})
export class LineItemCopyModalComponent implements OnInit {
  model: any;

  readonly onCopied = new Subject<LineItemCopyResult>();

  lineItem: any = {};
  isMarketplace = false;
  copy = {targeting: true, creatives: true};
  destination = true;
  disabled = false;
  validationErrors: any[] = [];

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(LineItemResource) private readonly LineItem: any,
    @Inject(AdnModalLoadingService) private readonly adnModalLoading: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.isMarketplace = LocalNetworkProfile.isMarketplacePlatform();
  }

  ngOnInit(): void {
    this.lineItem = _.cloneDeep(this.model || {});
    this.lineItem.name = nextCopyTitle(this.model?.name || '');
    this.lineItem.userState = 'PROPOSED';
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  copyCampaign(): void {
    this.disabled = true;
    this.validationErrors = [];
    this.adnModalLoading.applyModalLoading();
    const newId = Uuid.generate();
    const copyRequest = this.LineItem.copyLineItem(this.lineItem, newId, this.copy.targeting, this.copy.creatives, true);
    Promise.resolve(copyRequest.$promise || copyRequest).then(() => {
      // Defer disabled reset — sync then during modal CD races attr.disabled (NG0100).
      deferMarkForCheck(this.cdr, () => {
        this.disabled = false;
        this.adnModalLoading.removeModalLoading();
        completeCopyModal(this.bsModalRef, this.onCopied, {destination: this.destination, lineItemId: newId});
      });
    }, (errors: any) => {
      deferMarkForCheck(this.cdr, () => {
        this.disabled = false;
        this.validationErrors = (errors && errors.data && errors.data.errors) || [];
        this.adnModalLoading.removeModalLoading();
      });
    });
  }
}
